import { useService } from '@piwikpro/platform';
import { ListPreference } from '@piwikpro/user-preferences';

export const useStoredListLimit = (): number => {
  const userPreferences = useService('userPreferences');

  return new ListPreference(userPreferences.load(), '').limit;
};
